<template>
    <div class="row mr-1 d-flex align-items-center">
        <div class="text-muted mr-1">ต้องการสร้างพัสดุจำนวนมากใช่ไหม ?</div>
        <ImportExcel @onSuccess="onUpload">
            <template v-slot:header>
                <button class="btn btn-primary excel-download-button">สร้างพัสดุแบบอัพโหลด</button>
            </template>
        </ImportExcel>
        <div class="ml-1 mb-1 d-flex align-items-center">
            <div>
                <i class="fa fa-info-circle fa-xs mr-1" id="tooltip"  v-b-tooltip title="การอัพโหลดคือการสร้างหลายๆพัสดุพร้อมกัน โดยใช้ Excel"></i>
            </div>
            <div class="text-primary cursor-pointer" id="download-tooltip" @click="downloadShipmentExcelTemplate()" v-b-tooltip title="คลิกเพื่อดาวน์โหลดไฟล์ตัวอย่าง">ตัวอย่างไฟล์คลิกที่นี่</div>            
        </div>
    </div>
</template>
<script>
import ImportExcel  from '@/components/custom/pos/ImportExcel'
const ERROR_MSG = {
    invaid_format: 'กรุณากรอกข้อมูลตาม รูปแบบที่กำหนด',
    invaid_length: 'กรุณาสร้างรายการทีละ 50 รายการ'
}
const TYPR_ERROR_MSG = [ 'UPLOAD_EXCEL' ]
export default {
    name: 'CreateOrderByExcel',
    props:{
        courierKey: String,
    },
    data(){
        return {
            json: [],
            error: []
        }
    },
    components:{
        ImportExcel
    },
    methods:{
        downloadShipmentExcelTemplate() {
            let fileName = 'format_import_excel_cod';

            if( this.courierKey == 'SCG' ){
                fileName = 'format_import_excel_cod_SCG';
            }else if( ['SCGC' , 'SCGF'].includes(this.courierKey) ){
                fileName = 'format_import_excel_cod_SCGC-SCGF';
            // }else if( ['KRYS'].includes(this.courierKey) ){
            //     fileName = 'format_import_excel_cod_KERRY';
            }

            if( this.$THEME.name == 'quickexpress' ){
                fileName = fileName + '_QUICK'
            }
            
            window.open(`download/${fileName}.xlsx?v=` + process.env.VUE_APP_VERSION, '_blank');
        },
        onUpload( e ){
            if( e.status === true &&  e.data.length > 0 && this.countColumn(e.data) && this.countRow(e.data) ){
                this.json = e.data
                this.responseSuccess( this.json )
            }else{
                let typeError = '';
                let msgError = '';
                if( !this.countRow(e.data) ){
                    typeError = 'invaid_length';
                    msgError = ERROR_MSG.invaid_length
                }else{
                    typeError = Object.keys( ERROR_MSG )[0];
                    msgError = ERROR_MSG.invaid_format
                }
                this.error.push({
                    type: typeError,
                    msg: msgError
                })
                this.responseError( TYPR_ERROR_MSG[0] )
                
            }
        },
        countColumn( data ){
            return data.every(( col ) => {
                return Object.keys( col ).length > 11
            })
        },
        countRow( data ){
            return data.length <= (this.$THEME.maxImportShipment || 50)
        },
        responseSuccess( data ){
            return this.$emit( 'onSuccess', this.convertResponseSuccess(data) )
        },
        responseError( type ){
            return this.$emit( 'onError', this.convertResponseError(type, this.error) )
        },
        convertResponseSuccess( data ){
            return {
                status: true,
                data: data
            }
        },
        convertResponseError( type, data ){
            return {
                status: false,
                type: type,
                error: data
            }
        }
    }
}
</script>